(function () {
    'use strict';

    angular
        .module('stConfirmPopover', [])
        .directive('confirm', confirmDirective)
        .run(templateCache);

    function confirmDirective($compile, $parse, $sce) {
        return {
            scope: true,
            link: function (scope, element, attrs) {
                const confirmIf = attrs.confirmIf || 'true';
                const confirmYes = attrs.confirmYes;
                const confirmBypassed = attrs.confirmBypassed || confirmYes;

                scope.yesHtml = $sce.trustAsHtml("<span class ='glyphicon glyphicon-ok'></span> Yes");
                scope.noHtml = $sce.trustAsHtml("<span class ='glyphicon glyphicon-remove'></span> No");
                scope.popoverIsOpen = { value: false };

                scope.message = $sce.trustAsHtml(attrs.confirm || 'Are you sure?');
                element.removeAttr('confirm'); // necessary to avoid infinite compile loop

                scope.popoverTitle = attrs.confirmTitle || 'Confirm';
                scope.popoverPlacement = attrs.confirmPlacement || 'auto right';

                element.attr('uib-popover-template', "'confirmDirectiveTemplate.html'");
                element.attr('popover-trigger', "'none'");
                element.attr('popover-append-to-body', 'false');
                element.attr('popover-is-open', 'popoverIsOpen.value');
                element.attr('popover-title', '{{ popoverTitle }}');
                element.attr('popover-placement', '{{ popoverPlacement }}');

                if ('confirmMessage' in attrs) {
                    attrs.$observe('confirmMessage', function (val) {
                        scope.message = $sce.trustAsHtml(val || 'Are you sure?');
                    });
                    scope.message = $sce.trustAsHtml(attrs.confirmMessage || 'Are you sure?');
                }
                if ('confirmPlacement' in attrs) {
                    attrs.$observe('confirmPlacement', function (val) {
                        scope.popoverPlacement = val;
                    });
                }
                if ('confirmTitle' in attrs) {
                    attrs.$observe('confirmTitle', function (val) {
                        scope.popoverTitle = val;
                    });
                }

                element.bind('click', function (e) {
                    e.stopPropagation();

                    // if the confirm-if expression is not true, don't show confirm popover, just execute the confirm-bypassed function immediately
                    const ifFunc = $parse(confirmIf);
                    if (!ifFunc(scope)) {
                        scope.$apply(function () {
                            $parse(confirmBypassed)(scope);
                        });
                        return;
                    }

                    scope.$apply(() => {
                        scope.popoverIsOpen.value = true;
                    });
                });

                scope.yesClicked = () => {
                    $parse(attrs.confirmYes)(scope);
                    scope.popoverIsOpen.value = false;
                }

                scope.noClicked = () => {
                    scope.popoverIsOpen.value = false;
                };

                $compile(element)(scope);
            }
        }
    }

    confirmDirective.$inject = ['$compile', '$parse', '$sce'];


    function templateCache($templateCache) {
        var template =
            `
            <div class="stConfirmPopover">
                <div class="well" ng-bind-html="message"></div>
                <div class="row">
                    <div class="col-xs-6 text-left">
                        <button class ="btn btn-danger" ng-click="yesClicked()" translate
                            ng-bind-html="yesHtml"></button>
                    </div>
                    <div class="col-xs-6 text-right">
                        <button class="btn btn-default" ng-click="noClicked()" translate
                            ng-bind-html="noHtml"></button>
                    </div>
                </div>
            </div>
            `;
        $templateCache.put('confirmDirectiveTemplate.html', template);
    }

    templateCache.$inject = ['$templateCache'];

})();